

































import { downloadTemplate } from '@/utils/index'
import { virtualImportApi } from  '@/api/jhyc/juyc';

export default {
  name: 'StoreImport',
  data() {
    return {
      dialogTitle: '导入门店',
      dialogVisible: false,
      listLoading: false,
      tableData: [],
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
    },
    /** 下载模板 */
    downloadFile() {
      downloadTemplate('门店模板.xlsx', '/file/门店模板.xlsx')
    },
    /** 导入 */
    uploadFile(option) {
      if (option.file) {
        const data = new FormData()
        data.append('file', option.file)
        this.listLoading = true
        virtualImportApi(data).then((res) => {
          const newData = []
          for (let i = 0; i < res.successList.length; i++) {
            const modules = res.successList[i]
            newData.push(modules)
          }
          for (let i = 0; i < res.failureList.length; i++) {
            const modules = res.failureList[i]
            newData.push({
              ...modules.item,
              reason: modules.reason,
            })
          }
          this.tableData = newData
          const msg = res.total === res.successCount ? `成功导入${res.successCount}条数据` : '导入失败'
          this.$message.success(msg)
          /** 解决上传文件只允许上传一次的问题 */
          this.$refs.upload.clearFiles()
          this.$emit('success')
          this.listLoading = false
        })
      }
    },
  },
}
